import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cn } from '@whitbread-eos/utils';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Table = React.forwardRef((_ref, ref) => {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return _jsx("div", {
    className: "relative w-full",
    children: _jsx("table", _objectSpread({
      ref: ref,
      className: cn('text-base table-auto rounded-lg border border-separate border-spacing-0 border-lightGrey3 w-full font-normal text-4', className)
    }, props))
  });
});
Table.displayName = 'Table';
var TableHeader = React.forwardRef((_ref2, ref) => {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return _jsx("thead", _objectSpread({
    ref: ref,
    className: cn('bg-successTint px-4 py-2 h-10 font-normal', className)
  }, props));
});
TableHeader.displayName = 'TableHeader';
var TableBody = React.forwardRef((_ref3, ref) => {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return _jsx("tbody", _objectSpread({
    ref: ref,
    className: cn('h-10', className)
  }, props));
});
TableBody.displayName = 'TableBody';
var TableFooter = React.forwardRef((_ref4, ref) => {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return _jsx("tfoot", _objectSpread({
    ref: ref,
    className: cn('', className)
  }, props));
});
TableFooter.displayName = 'TableFooter';
var TableRow = React.forwardRef((_ref5, ref) => {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return _jsx("tr", _objectSpread({
    ref: ref,
    className: cn('hover:bg-muted/50', className)
  }, props));
});
TableRow.displayName = 'TableRow';
var TableHead = React.forwardRef((_ref6, ref) => {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return _jsx("th", _objectSpread({
    ref: ref,
    className: cn('font-normal text-left px-4', className)
  }, props));
});
TableHead.displayName = 'TableHead';
var TableCell = React.forwardRef((_ref7, ref) => {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return _jsx("td", _objectSpread({
    ref: ref,
    className: cn('border-t border-lightGrey2 px-4 h-10', className)
  }, props));
});
TableCell.displayName = 'TableCell';
var TableCaption = React.forwardRef((_ref8, ref) => {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return _jsx("caption", _objectSpread({
    ref: ref,
    className: cn('', className)
  }, props));
});
TableCaption.displayName = 'TableCaption';
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };